export enum SubscriptionTypeEnum {
  TRIAL = 'TRIAL',
  SUBSCRIPTION = 'SUBSCRIPTION',
  PURCHASE = 'PURCHASE',
  NESTED_SUBSCRIPTION = 'NESTED_SUBSCRIPTION'
}
